// extracted by mini-css-extract-plugin
export default {"recos":"E6-z","productCardOverride":"F6-z","rowHasBadge":"G6-z"};